import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import WhyChooseUs from './components/WhyChooseUs';
import InsuranceSection from './components/InsuranceSection';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesPreview />
        <WhyChooseUs />
        <InsuranceSection />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
